<template>
  <div class="index-page container">
    <n-card :loading="$var('load')" style="max-width: 800px;">
      <n-form @submit="submit">
        <n-items>
          <n-input title="Заголовок" v-bind="$form.input('title')" />
          <n-textarea title="Описание" v-bind="$form.input('content')" />
          <n-upload title="Файл" :value.sync="image" />
          <n-button color="primary" wide type="submit">Сохранить</n-button>
        </n-items>
      </n-form>
    </n-card>
  </div>
</template>

<script>
export default {
  name: 'Index',
  data: () => ({
    image: null,
  }),
  mounted() {
    this.$form.init({
      title: '',
      desc: '',
      content: '',
    })
  },
  methods: {
    submit() {
      this.$var('load', true)
      if (this.image) {
        $api.files.create({ file: this.image, }).then((file) => {
          this.save(file.data.content.id).finally(() => {
            this.$var('load', false)
          })
        }).catch(() => {
          this.$var('load', false)
        })
      } else {
        this.save().finally(() => {
          this.$var('load', false)
        })
      }
    },
    save(file) {
      const data = {
        ...this.$form.get(),
        file,
      }
      return $api.app.documents.create(data).then((result) => {
        this.$router.push({ name: 'documents.edit', params: { id: result.data.content.id, }, })
      })
    },
  },
}
</script>

<style lang="scss" scoped>
  .index-page {
  
  }
</style>
